import React, { Component } from 'react';
import fileDownload from 'js-file-download';
import { convertDate } from '../../../utils/utils';

import AttachmentIcon from '../../icons/AttachmentIcon';
import CheckboxIcon from '../../icons/CheckboxIcon';

class AssessmentsListItem extends Component {
  handleClick = (e) => {
    if (document.querySelector(`#col-1-${this.props.item.id}`).contains(e.target)) {
      // We checked a checkbox, so ignore the click
      return false;
    }
    this.navigate();
  }

  handleKeyDown = (e) => {
    if (document.querySelector(`#col-1-${this.props.item.id}`).contains(e.target)) {
      // We're on a checkbox, so ignore the click
      return false;
    }
    if (e.keyCode === 13) {
      this.navigate();
    }
  }

  navigate = () => {
    if (!this.props.enabled) {
      return false;
    }
    if (this.props.item.uploaded) {
      this.props.assessmentsActions.downloadAssessment(this.props.item.id, this.onSuccess)
    } else if (this.props.item.dateCompleted) {
      this.props.history.push(`/review?assessments[]=${this.props.item.id}`);
    } else {
      this.props.history.push(`/assessments/${this.props.item.id}/${this.lastQuestionIndex}`);
    }
  }

  onSuccess = (response) => {
    fileDownload(response, "assessment.pdf", "application/pdf");
  }

  render() {
    const { toggleCheckbox, checked, item, user, enabled = true, section = { title: '', theme: '' } } = this.props;
    this.lastQuestionIndex = item.lastQuestionIndex ? item.lastQuestionIndex + 1 : 1;
    return (
      <div
        className={'assessments-list__card' + (item.uploaded ? ' assessments-list__card--uploaded' : '') + (!enabled ? ' assessments-list__card--disabled' : '')}
        onClick={this.handleClick}
        onKeyDown={this.handleKeyDown}
        tabIndex={this.props.enabled ? 0 : -1}
      >
        {item.uploaded || !item.dateCompleted
          ? <div className="assessments-list__col-1" id={`col-1-${item.id}`} />
          : <label className="assessments-list__checkbox assessments-list__col-1" id={`col-1-${item.id}`}>
              <input
                type="checkbox"
                checked={checked}
                disabled={item.uploaded || !enabled || !item.dateCompleted}
                onChange={toggleCheckbox}
              />
              <CheckboxIcon value={checked} disabled={item.uploaded || !item.dateCompleted} />
            </label>
        }
        <div className={"assessments-list__section assessments-list__col-2 color--" + section.theme}>
          {section.title}
        </div>
        <div className="assessments-list__date assessments-list__col-3">
          { // Uploaded PDFs should show their custom date;
            // other assessments should show when they were started.
            item.uploaded ? convertDate(item.dateCompleted) : convertDate(item.createdAt)
          }
        </div>
        <div className="assessments-list__date assessments-list__col-4">
          {item.dateCompleted
            // we need to use updatedAt instead of dateCompleted since the latter changes for PDFs
            ? convertDate(item.updatedAt)
            : (
              <span className="assessments-list__in-progress">
                <span className="hover-hide">
                  In Progress
                </span>
                <span className="hover-show">
                  Continue
                </span>
              </span>
            )
          }
          {item.uploaded && <AttachmentIcon color="gray" />}
        </div>
        <div className="assessments-list__name assessments-list__col-5">
          {user && (user.firstName + ' ' + user.lastName)}
        </div>
      </div>
    );
  }
}

export default AssessmentsListItem;



// WEBPACK FOOTER //
// ./src/components/features/dashboard/AssessmentsListItem.js